import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Articles.css";

const Articles = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    // Load blogs from localStorage
    const savedBlogs = localStorage.getItem("blogs");
    if (savedBlogs) {
      setBlogs(JSON.parse(savedBlogs));
    }
  }, []);

  const handleBlogClick = (blogId) => {
    navigate(`/article/${blogId}`);
  };

  return (
    <div className="articles-page">
      <div className="container">
        <h2 className="articles-title">
          <span style={{ color: "#002D62" }}>Our </span>
          <span style={{ color: "#00AEEF" }}>Articles</span>
        </h2>

        {blogs.length === 0 ? (
          <div className="no-articles">
            <p>No articles available. Check back soon!</p>
          </div>
        ) : (
          <div className="articles-grid">
            {blogs.map((blog) => (
              <div 
                key={blog.id} 
                className="article-card"
                onClick={() => handleBlogClick(blog.id)}
              >
                <img 
                  src={blog.image || "https://via.placeholder.com/400x200/003366/FFFFFF?text=Article"} 
                  alt={blog.title} 
                  className="article-img" 
                />
                <div className="article-body">
                  <span className="article-category">{blog.category}</span>
                  <h5 className="article-card-title">{blog.title}</h5>
                  <p className="article-card-desc">{blog.description}</p>
                  <hr />
                  <div className="article-footer">
                    <span className="article-author">{blog.author}</span>
                    <span className="article-date">{blog.date}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Articles;